import { render, staticRenderFns } from "./LpuLogoPicture.vue?vue&type=template&id=d0e4e1ca&"
import script from "./LpuLogoPicture.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLogoPicture.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0e4e1ca')) {
      api.createRecord('d0e4e1ca', component.options)
    } else {
      api.reload('d0e4e1ca', component.options)
    }
    module.hot.accept("./LpuLogoPicture.vue?vue&type=template&id=d0e4e1ca&", function () {
      api.rerender('d0e4e1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLogoPicture/LpuLogoPicture.vue"
export default component.exports